export const sortTerms = (terms: any) => {
  if (Array.isArray(terms))
    return terms.sort((t1: any, t2: any) => {
      if (t1.name < t2.name) return -1;
      if (t1.name > t2.name) return 1;
      return 0;
    });
  return terms;
};
